import { Sender } from 'xstate';

import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import FullScreenFrontend from '../../../ports-frontend/FullScreen';

export const watchFullScreenMode = () =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'ENVIRONMENT_FULL_SCREEN_CHANGED';
        data: {
          isFullScreen: boolean;
        };
      }>
    ) => {
      const subscriptions: Function[] = [];
      subscriptions.push(
        await FullScreenFrontend.onFullScreenChange((isFullScreen: boolean) => {
          callback({
            type: 'ENVIRONMENT_FULL_SCREEN_CHANGED',
            data: {
              isFullScreen,
            },
          });
        })
      );
      return () => {
        subscriptions.forEach(unsub => unsub());
      };
    }
  );
